import {XMarkIcon} from "@heroicons/react/20/solid";
import {PropsWithChildren, ReactNode} from "react";
import {OtsIconActionButton} from "./OtsButton";

export type OtsSelectionBarProps = PropsWithChildren<{
  /** Number of selected items; the bar renders nothing at zero. */
  count: number;
  /** What is selected, singular, e.g. "ticket". */
  noun?: string;
  /** Totals for the selection, shown beside the count. */
  summary?: ReactNode;
  onClear: () => void;
  className?: string;
}>;

/** Bulk actions for the current selection. Appears only while something is selected. */
export const OtsSelectionBar = ({count, noun = "item", summary, onClear, className, children}: OtsSelectionBarProps) => {
  if (count <= 0) return null;

  return <div
    role="toolbar"
    aria-label="Selection actions"
    className={[
      "flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-[var(--ots-outline)] bg-[var(--ots-surface)] px-3 py-2 text-sm shadow-xl",
      className,
    ].filter(Boolean).join(" ")}>
    <OtsIconActionButton variant="text" size="compact" icon={<XMarkIcon/>} label="Clear selection" onClick={onClear}/>
    <span aria-live="polite" className="font-semibold">{count} {noun}{count === 1 ? "" : "s"} selected</span>
    {summary != null && <span className="text-[var(--ots-text-muted)] tabular-nums">{summary}</span>}
    {children != null && <span className="ml-auto flex flex-wrap items-center gap-2">{children}</span>}
  </div>;
};
